module.exports = __webpack_public_path__ + "img/scared.35142e29.jpg";